import { render, staticRenderFns } from "./teaDynamicStatic.vue?vue&type=template&id=99f1feac&scoped=true"
import script from "./teaDynamicStatic.vue?vue&type=script&lang=js"
export * from "./teaDynamicStatic.vue?vue&type=script&lang=js"
import style0 from "./teaDynamicStatic.vue?vue&type=style&index=0&id=99f1feac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f1feac",
  null
  
)

export default component.exports